module.exports = __webpack_public_path__ + "media/images/admin2/InputSearch-27952aa4909f34cb46cd5004f0ae0557.svg";